import React, { useState, useEffect, useRef, useMemo } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from "sweetalert";
import AuthCheckComponent from '../../Layouts/Token';
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ls from "local-storage";
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import PageLoader from '../../Layouts/PageLoader';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import InputAdornment from '@material-ui/core/InputAdornment';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import ImageIcon from '@material-ui/icons/Image';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DescriptionIcon from '@material-ui/icons/Description';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';

import './TaskManagement.css';
import '../Leaves/Leave.css';
import './job.css';
import moment from 'moment';
import TimelineInputField, { clampAndFormatTimeline, validateTimeline } from './TimelineInputField';
import WysiwygDescriptionEditor from './WysiwygDescriptionEditor';
import FilePreviewDialog, { downloadFileDirect } from './FilePreviewDialog';
import { isProjectActive } from '../../../utils/projectStatus';

const TrayUploadIcon = ({ size = 20, style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={style}
    >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
);

const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

const EditTask = (props) => {
    const classes = props;
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [taskData, setTaskData] = useState({
        task: '',
        project_name: '',
        developer_name: '',
        developer_user_id: '',
        member_ids: [],
        timeline: '',
        task_date_time: '',
        description: '',
        status: '',
        priority: 'Medium',
        task_deliver_date: '',
    });
    const [developers, setDevelopers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [subTasks, setSubTasks] = useState([]);
    const [subTaskFields, setSubTaskFields] = useState([]);
    const [newSubTaskTitle, setNewSubTaskTitle] = useState('');
    const [newSubTaskStatus, setNewSubTaskStatus] = useState('Pending');
    const [editingIndex, setEditingIndex] = useState(null);
    const [editSubTaskTitle, setEditSubTaskTitle] = useState('');
    const [editSubTaskStatus, setEditSubTaskStatus] = useState('Pending');

    const handleAddSubTask = () => {
        const trimmed = (newSubTaskTitle || '').trim();
        if (!trimmed) {
            swal('Warning', 'Please enter a subtask title.', 'warning');
            return;
        }
        const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
        setSubTasks((prev) => [
            ...prev,
            {
                name: trimmed,
                status: isBacklogTask ? 'Backlog' : (newSubTaskStatus || 'Pending'),
                details: trimmed
            }
        ]);
        setNewSubTaskTitle('');
        setNewSubTaskStatus(isBacklogTask ? 'Backlog' : 'Pending');
    };

    const handleDeleteSubTask = (index) => {
        swal({
            title: 'Are you sure?',
            text: 'Do you want to delete this subtask?',
            icon: 'warning',
            buttons: ['Cancel', 'Yes, Delete'],
            dangerMode: true
        }).then((confirmed) => {
            if (confirmed) {
                setSubTasks((prev) => prev.filter((_, i) => i !== index));
                if (editingIndex === index) {
                    setEditingIndex(null);
                }
            }
        });
    };

    const handleStartEditSubTask = (index) => {
        setEditingIndex(index);
        const st = subTasks[index];
        setEditSubTaskTitle((st && (st.name || st.title || st.details)) || '');
        setEditSubTaskStatus((st && st.status) || 'Pending');
    };

    const handleSaveEditSubTask = (index) => {
        const trimmed = (editSubTaskTitle || '').trim();
        if (!trimmed) {
            return;
        }
        const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
        const finalStatus = isBacklogTask ? 'Backlog' : (editSubTaskStatus || 'Pending');
        setSubTasks((prev) =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, name: trimmed, status: finalStatus, details: trimmed }
                    : item
            )
        );
        setEditingIndex(null);
    };

    const handleCancelEditSubTask = () => {
        setEditingIndex(null);
    };
    const [userPopoverAnchor, setUserPopoverAnchor] = useState(null);
    const [userSearchQuery, setUserSearchQuery] = useState('');
    const avatarsScrollRef = useRef(null);
    const [taskFiles, setTaskFiles] = useState([]);
    const [previewFile, setPreviewFile] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const selected = Array.from(e.target.files || []);
        if (selected.length > 0) {
            setTaskFiles((prev) => [...prev, ...selected]);
        }
        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to remove this file?",
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        }).then((confirm) => {
            if (confirm) {
                setTaskFiles((prev) => prev.filter((_, i) => i !== index));
            }
        });
    };

    const handleDownloadFile = (file) => {
        downloadFileDirect(file);
    };

    const handleViewFile = (file) => {
        if (!file) return;
        if (file instanceof File) {
            const blobUrl = window.URL.createObjectURL(file);
            setPreviewFile({
                url: blobUrl,
                name: file.name,
                type: file.type,
                size: file.size,
            });
        } else {
            setPreviewFile(file);
        }
    };



    useEffect(() => {
        const el = avatarsScrollRef.current;
        if (!el) return;

        const handleWheel = (e) => {
            const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
            if (delta !== 0) {
                e.preventDefault();
                e.stopPropagation();
                el.scrollBy({ left: Math.sign(delta) * 44, behavior: 'smooth' });
            }
        };

        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            el.removeEventListener('wheel', handleWheel);
        };
    }, [taskData.member_ids]);

    useEffect(() => {
        const loadInitialData = async () => {
            setPageLoading(true);
            try {
                await Promise.all([fetchDevelopers(), fetchProjects(), fetchTaskData()]);
            } finally {
                setPageLoading(false);
            }
        };
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
        loadInitialData();
    }, [props?.match?.params?.id]);

    const fetchDevelopers = async () => {
        try {
            const response = await AuthApi.getData();
            if (response && response.data) {
                const loggedUsers = response.data.filter((user) => Number(user.user_logged) === 1);
                setDevelopers(loggedUsers.length > 0 ? loggedUsers : response.data);
            } else {
                console.error("Failed to fetch users");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const extractIds = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw
                .map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item))
                .map(Number)
                .filter((id) => !isNaN(id));
        }
        if (typeof raw === 'string') {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    return parsed
                        .map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item))
                        .map(Number)
                        .filter((id) => !isNaN(id));
                }
            } catch (_) {
                return raw.split(',').map(Number).filter((id) => !isNaN(id));
            }
        }
        if (typeof raw === 'number') {
            return [raw];
        }
        return [];
    };

    const isUserSuperAdmin = () => {
        try {
            const roles = ls.get('roles') || ls('roles') || (props.authUser && props.authUser.roles);
            const role = ls.get('role') || ls('role') || (props.authUser && props.authUser.role);
            const adminRoles = ['super admin', 'admin', 'administrator'];
            if (typeof role === 'string' && adminRoles.includes(role.trim().toLowerCase())) return true;
            if (typeof roles === 'string' && adminRoles.includes(roles.trim().toLowerCase())) return true;
            if (Array.isArray(roles)) {
                return roles.some((r) => {
                    const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
                    return adminRoles.includes(name);
                });
            }
            return false;
        } catch (_) {
            return false;
        }
    };

    const fetchProjects = async () => {
        try {
            const response = await AuthApi.getProject();
            if (response && response.status && Array.isArray(response.data)) {
                let activeProjects = response.data.filter(project => !project.deleted);

                const isSuperAdmin = isUserSuperAdmin();
                let currentUser = ls.get('user') || ls('user') || {};
                if (typeof currentUser === 'string') {
                    try { currentUser = JSON.parse(currentUser); } catch (_) {}
                }
                if ((!currentUser || typeof currentUser !== 'object') && typeof window !== 'undefined') {
                    const raw = window.localStorage.getItem('user');
                    if (raw) {
                        try { currentUser = JSON.parse(raw); } catch (_) {}
                    }
                }
                const currentUserId = (currentUser && (currentUser.id || currentUser._id || currentUser.user_id)) || null;

                if (!isSuperAdmin) {
                    if (!currentUserId) {
                        activeProjects = [];
                    } else {
                        const uid = Number(currentUserId);
                        activeProjects = activeProjects.filter((p) => {
                            const members = extractIds(p.member_ids);
                            const leads = [
                                ...extractIds(p.lead_ids),
                                ...(p.lead_id ? extractIds(p.lead_id) : [])
                            ];
                            return [...members, ...leads].includes(uid);
                        });
                    }
                }

                setProjects(activeProjects);
            } else {
                console.error("Failed to fetch projects");
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const fetchTaskData = async () => {
        const taskId = props.match.params.id; 
        try {
            const response = await AuthApi.taskgetbyid(taskId);
            console.log("API Response:", response);
            if (response && response.status) {
                const taskDetails = response.data;
                let devUserId = '';
                if (taskDetails.developer_name) {
                    devUserId = taskDetails.developer_user_id || '';
                }

                let resolvedMemberIds = [];
                if (taskDetails.member_ids && Array.isArray(taskDetails.member_ids) && taskDetails.member_ids.length > 0) {
                    resolvedMemberIds = taskDetails.member_ids.map(Number);
                } else if (taskDetails.developer_user_ids && Array.isArray(taskDetails.developer_user_ids) && taskDetails.developer_user_ids.length > 0) {
                    resolvedMemberIds = taskDetails.developer_user_ids.map(Number);
                } else if (taskDetails.developer_user_id) {
                    resolvedMemberIds = [Number(taskDetails.developer_user_id)];
                }

                let calculatedTimeline = taskDetails.timeline || taskDetails.duration || '';
                if (calculatedTimeline && typeof calculatedTimeline === 'string') {
                    calculatedTimeline = clampAndFormatTimeline(calculatedTimeline) || calculatedTimeline.replace(/hr/gi, '').trim();
                }
                if (!calculatedTimeline && taskDetails.task_date_time && taskDetails.task_deliver_date) {
                    const s = moment(taskDetails.task_date_time);
                    const d = moment(taskDetails.task_deliver_date);
                    if (s.isValid() && d.isValid()) {
                        const diffM = Math.max(0, d.diff(s, 'minutes'));
                        const h = Math.min(8, Math.floor(diffM / 60));
                        const m = h === 8 ? 0 : diffM % 60;
                        calculatedTimeline = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                    }
                }

                setTaskData(prev => ({
                    ...prev,
                    id: taskId,
                    project_task_id: taskDetails.project_task_id || '',
                    task: taskDetails.task || '',
                    project_name: taskDetails.project_name || '',
                    developer_name: taskDetails.developer_name || '',
                    developer_user_id: devUserId,
                    member_ids: resolvedMemberIds,
                    timeline: calculatedTimeline || '00:00',
                    task_date_time: taskDetails.task_date_time || '',
                    description: taskDetails.description || '',
                    status: taskDetails.status || '',
                    priority: taskDetails.priority || 'Medium',
                    task_deliver_date: taskDetails.task_deliver_date || '',
                }));
                // Set description as plain text (for textarea)
                let descText = '';
                if (taskDetails.description) {
                    try {
                        const parsed = JSON.parse(taskDetails.description);
                        if (parsed && parsed.blocks) {
                            descText = parsed.blocks.map(b => b.text).join('\n');
                        } else {
                            descText = taskDetails.description;
                        }
                    } catch (e) {
                        descText = taskDetails.description;
                    }
                }
                setTaskData(prev => ({ ...prev, description: descText }));

                // Parse and initialize sub-task fields
                let initialSubTasks = [];
                const rawSubTasks = taskDetails.sub_tasks || taskDetails.subTasks;
                if (rawSubTasks) {
                    try {
                        let parsed = typeof rawSubTasks === 'string'
                            ? JSON.parse(rawSubTasks)
                            : rawSubTasks;
                        while (typeof parsed === 'string') {
                            parsed = JSON.parse(parsed);
                        }
                        if (Array.isArray(parsed)) {
                            const isTaskBacklog = String(taskDetails.status || '').trim().toLowerCase() === 'backlog';
                            const parentKey = taskDetails.project_task_id || taskId || '';
                            initialSubTasks = parsed.map((st, idx) => {
                                if (typeof st === 'string') {
                                    st = { name: st, details: st, status: 'Pending' };
                                }
                                const subNum = idx + 1;
                                const rawChild = (st && (st.child_id || st.sub_task_id)) || (parentKey ? `${parentKey}.${subNum}` : String(subNum));
                                const title = (st && (st.name || st.title || st.task_name || st.task || st.details)) ? String(st.name || st.title || st.task_name || st.task || st.details).trim() : `Subtask ${subNum}`;
                                return {
                                    ...st,
                                    id: (st && st.id) || subNum,
                                    parent_id: (st && st.parent_id) || parentKey,
                                    child_id: rawChild,
                                    sub_task_id: rawChild,
                                    name: title,
                                    status: isTaskBacklog ? 'Backlog' : ((st && st.status) || 'Pending'),
                                    details: (st && (st.details || title)) ? String(st.details || title).trim() : title
                                };
                            });
                        }
                    } catch (e) {
                        initialSubTasks = [];
                    }
                }
                setSubTasks(initialSubTasks);

                // Parse and initialize attached files
                let initialFiles = [];
                if (taskDetails.files) {
                    try {
                        let parsedFiles = typeof taskDetails.files === 'string'
                            ? JSON.parse(taskDetails.files)
                            : taskDetails.files;
                        while (typeof parsedFiles === 'string') {
                            parsedFiles = JSON.parse(parsedFiles);
                        }
                        if (Array.isArray(parsedFiles)) {
                            initialFiles = parsedFiles;
                        } else if (parsedFiles && typeof parsedFiles === 'object') {
                            initialFiles = [parsedFiles];
                        }
                    } catch (e) {
                        initialFiles = [];
                    }
                }
                const validInitialFiles = initialFiles.filter(f => {
                    if (!f) return false;
                    if (typeof f === 'string' && f.trim()) return true;
                    if (typeof f === 'object' && (f.url || f.name || f.file_name)) return true;
                    return false;
                });
                setTaskFiles(validInitialFiles);

                // Match project name with fetched projects
                const matchedProject = response.data.project_name;
                if (matchedProject) {
                    const project = projects.find(proj => proj.project_name === matchedProject);
                    if (project) {
                        setTaskData(prevState => ({
                            ...prevState,
                            project_name: project.project_name
                        }));
                    }
                }
            } else {
                console.error("Failed to fetch task data");
            }
        } catch (error) {
            console.error("Error fetching task data:", error);
        }
    };

    useEffect(() => {
        if (developers.length > 0 && taskData.developer_name && (!taskData.member_ids || taskData.member_ids.length === 0)) {
            const names = taskData.developer_name.split(',').map(n => n.trim().toLowerCase()).filter(Boolean);
            if (names.length > 0) {
                const matched = new Set((taskData.member_ids || []).map(Number));
                names.forEach(name => {
                    const dev = developers.find(d => {
                        const full = `${d.firstName || ''} ${d.lastName || ''}`.trim().toLowerCase();
                        const first = (d.firstName || '').trim().toLowerCase();
                        const alt = (d.name || '').trim().toLowerCase();
                        return full === name || first === name || alt === name;
                    });
                    if (dev) {
                        matched.add(Number(dev.id));
                    }
                });
                const updatedIds = Array.from(matched);
                if (updatedIds.length > 0) {
                    setTaskData(prev => ({
                        ...prev,
                        member_ids: updatedIds
                    }));
                }
            }
        }
    }, [developers, taskData.developer_name]);

    useEffect(() => {
        if (developers.length > 0 && taskData.member_ids && taskData.member_ids.length > 0) {
            const activeDevIds = new Set(developers.map(d => Number(d.id)));
            const valid = taskData.member_ids.filter(id => activeDevIds.has(Number(id)));
            if (valid.length !== taskData.member_ids.length) {
                setTaskData(prev => ({
                    ...prev,
                    member_ids: valid
                }));
            }
        }
    }, [developers, taskData.member_ids]);

    const selectedProject = useMemo(() => {
        if (!taskData.project_name) return null;
        return projects.find(
            (p) => String(p.project_name).trim().toLowerCase() === String(taskData.project_name || '').trim().toLowerCase() ||
                   String(p.id) === String(taskData.project_name || '')
        ) || null;
    }, [taskData.project_name, projects]);

    const projectUserIds = useMemo(() => {
        if (!selectedProject) return [];
        const members = extractIds(selectedProject.member_ids);
        const leads = extractIds(selectedProject.lead_ids);
        return Array.from(new Set([...members, ...leads]));
    }, [selectedProject]);

    const availableDevelopers = useMemo(() => {
        if (!taskData.project_name) {
            return [];
        }
        if (projectUserIds.length === 0) {
            return [];
        }
        return developers.filter((dev) => projectUserIds.includes(Number(dev.id)));
    }, [taskData.project_name, projectUserIds, developers]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "developer_user_id") {
            const selectedDeveloper = developers.find(dev => String(dev.id) === String(value));
            setTaskData({
                ...taskData,
                developer_user_id: value,
                developer_name: selectedDeveloper ? (selectedDeveloper.firstName + (selectedDeveloper.lastName ? ' ' + selectedDeveloper.lastName : '')) : ''
            });
        } else if (name === 'project_name') {
            const selectedProj = projects.find(
                (p) => String(p.project_name).trim().toLowerCase() === String(value || '').trim().toLowerCase() ||
                       String(p.id) === String(value || '')
            );
            const projMemberIds = selectedProj
                ? Array.from(new Set([...extractIds(selectedProj.member_ids), ...extractIds(selectedProj.lead_ids)]))
                : [];

            setTaskData((prev) => ({
                ...prev,
                project_name: value,
                member_ids: projMemberIds.length > 0
                    ? (prev.member_ids || []).filter((uid) => projMemberIds.includes(Number(uid)))
                    : []
            }));
        } else {
            setTaskData({ ...taskData, [name]: value });
            if (name === 'status' && String(value).trim().toLowerCase() === 'backlog') {
                setSubTasks(prev => prev.map(st => ({ ...st, status: 'Backlog' })));
            }
        }
        if (formErrors[name]) {
            setFormErrors((prev) => ({ ...prev, [name]: '' }));
        }
    };



    const handleSubTaskFieldChange = (index, field, value) => {
        const updatedFields = subTaskFields.map((subTask, i) => 
            i === index ? { ...subTask, [field]: value } : subTask
        );
        setSubTaskFields(updatedFields);
    };

    const handleSubTaskEditorChange = (index, state) => {
        const updatedFields = subTaskFields.map((subTask, i) => 
            i === index ? { ...subTask, editorState: state } : subTask
        );
        setSubTaskFields(updatedFields);
    };

    const handleAddSubTaskField = () => {
        setSubTaskFields([...subTaskFields, { name: '', status: '', editorState: EditorState.createEmpty() }]);
    };

    const handleRemoveSubTaskField = (index) => {
        setSubTaskFields(subTaskFields.filter((_, i) => i !== index));
    };

    // Format time into DB YYYY-MM-DD HH:mm:ss format (date saved automatically in DB, only time in front)
    const formatToDbDateTime = (timeStr) => {
        if (!timeStr || !timeStr.trim()) return null;
        const trimmed = timeStr.trim();
        const today = moment().format('YYYY-MM-DD');

        // If string already has a date part, parse it directly
        if (trimmed.includes('-') || trimmed.includes('/')) {
            const m = moment(trimmed, [
                'DD/MM/YYYY hh:mm A',
                'DD/MM/YYYY HH:mm',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm',
                'YYYY-MM-DD'
            ]);
            return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : trimmed;
        }

        // Pure time string: HH:mm or HH:mm:ss or hh:mm A
        const m = moment(`${today} ${trimmed}`, [
            'YYYY-MM-DD HH:mm',
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DD hh:mm A',
            'YYYY-MM-DD h:mm A'
        ]);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : `${today} ${trimmed}:00`;
    };

    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const ds = /^[0-9\b]+$/;

        if (!values.task) {
            errors.task = "Task name is required";
        }
        if (!values.project_name) {
            errors.project_name = "Project name is required";
        }
        if (values.timeline) {
            const tlCheck = validateTimeline(values.timeline);
            if (!tlCheck.isValid) {
                errors.timeline = tlCheck.error;
            }
        }
        if (!values.status) {
            errors.status = "Status is required";
        }
        if (!values.member_ids || values.member_ids.length === 0) {
            errors.member_ids = "Please select at least one user";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(taskData);
        setFormErrors(errors);

        if (Object.keys(errors).length === 0) {
            await updateTask();
        }
    };

    const updateTask = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: createSwalLoaderNode()
        });

        try {
            const devNames = (taskData.member_ids || []).map((id) => {
                const u = developers.find((d) => Number(d.id) === Number(id));
                return u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() : '';
            }).filter(Boolean).join(', ');

            const primaryDevId = (taskData.member_ids && taskData.member_ids.length > 0)
                ? taskData.member_ids[0]
                : '';

            const { id, ...taskPayload } = taskData;
            const cleanTimeline = clampAndFormatTimeline(taskData.timeline || '00:00') || '00:00 hr';
            const [th, tm] = cleanTimeline.replace(/[^0-9:]/g, '').split(':').map(Number);
            const totalMins = (isNaN(th) ? 0 : th) * 60 + (isNaN(tm) ? 0 : tm);
            const startMoment = taskData.task_date_time ? moment(taskData.task_date_time) : moment();
            const validStart = startMoment.isValid() ? startMoment : moment();
            const deliverMoment = validStart.clone().add(totalMins, 'minutes');

            const formattedTimeline = cleanTimeline
                ? (cleanTimeline.includes('hr') ? cleanTimeline : `${cleanTimeline} hr`)
                : '';

            taskPayload.developer_name = devNames;
            taskPayload.developer_user_id = primaryDevId;
            taskPayload.developer_user_ids = taskData.member_ids || [];
            taskPayload.member_ids = taskData.member_ids || [];
            taskPayload.timeline = formattedTimeline || cleanTimeline;
            taskPayload.duration = formattedTimeline || cleanTimeline;
            taskPayload.task_date_time = validStart.format('YYYY-MM-DD HH:mm:ss');
            taskPayload.task_deliver_date = deliverMoment.format('YYYY-MM-DD HH:mm:ss');
            // description is already plain text from textarea
            const targetId = props?.match?.params?.id || id || taskData.id;
            const parentKey = taskData.project_task_id || targetId || '';
            const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
            const cleanSubTasks = subTasks.map((subTask, idx) => {
                const subNum = idx + 1;
                const childId = subTask.child_id || subTask.sub_task_id || `${parentKey}.${subNum}`;
                const title = (subTask.name || subTask.title || subTask.task_name || subTask.task || subTask.details || '').trim();
                return {
                    id: subTask.id || subNum,
                    parent_id: subTask.parent_id || parentKey,
                    child_id: childId,
                    sub_task_id: childId,
                    name: title || `Subtask ${subNum}`,
                    status: isBacklogTask ? 'Backlog' : (subTask.status || 'Pending'),
                    details: (subTask.details || title || `Subtask ${subNum}`).trim()
                };
            });
            taskPayload.sub_tasks = cleanSubTasks;
            taskPayload.subTasks = cleanSubTasks;

            if (String(taskData.status || '').trim().toLowerCase() === 'done') {
                const hasPending = cleanSubTasks.some(st => String(st.status || '').trim().toLowerCase() !== 'done');
                if (hasPending) {
                    swal({
                        title: "Subtasks Pending",
                        text: "Please complete all subtasks first before marking this task as Done.",
                        icon: "warning"
                    });
                    setSubmitLoading(false);
                    return;
                }
            }

            // Upload newly added files if any
            let uploadedFilesList = [];
            if (taskFiles && taskFiles.length > 0) {
                uploadedFilesList = await Promise.all(
                    taskFiles.map(async (f) => {
                        if (f instanceof File || (f && f.name && !f.url)) {
                            const res = await AuthApi.uploadTaskFile(f);
                            if (res && res.status && res.data) {
                                return res.data;
                            }
                            console.error('File upload failed for', f.name, res);
                            return null;
                        }
                        return (f && (f.url || f.name)) ? f : null;
                    })
                );
                uploadedFilesList = uploadedFilesList.filter(Boolean);
            }
            taskPayload.files = uploadedFilesList;

            const response = await AuthApi.updateTask(targetId, taskPayload);
            if (response && response.status) {
                if (typeof AuthApi.invalidateCache === 'function') {
                    AuthApi.invalidateCache('getTasks');
                }
                swal.close();
                swal("Success", "Task updated successfully", "success").then(() => {
                    props.history.push('/tasks');
                });
            } else {
                swal.close();
                swal("Error", response.message || "Failed to update task", "error");
            }
        } catch (error) {
            swal.close();
            console.error("Error updating task:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    const uploadImageCallBack = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new window.FileReader();
            reader.onloadend = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.readAsDataURL(file);
        });
    };

    const isSuperAdmin = ls("roles") === "Super Admin";

    if (pageLoading) {
        return (
            <div>
                <AuthCheckComponent authToken={props.authToken} />
                <Header {...props} authUser={props.authUser} component={<PageLoader />} />
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div style={{ marginBottom: '11%' }}>
                        <div className="holiday-breadcrumb-card">
                            <Breadcrumb
                                {...props}
                                primaryPageName="Tasks"
                                primaryPageLink="/tasks"
                                isSecondaryPage={true}
                                secondaryPageName="Edit Task"
                            />
                        </div>
                        <div className="holiday-form-card">
                            <Typography
                                variant="h2"
                                className="holiday-form-title"
                                style={{ color: '#036dda', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}
                            >
                                Edit Task
                            </Typography>
                            <form className="common-form-fields" onSubmit={handleSubmit} noValidate>
                                <Grid container spacing={4}>
                                    {/* 1. Task Name */}
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="Task name"
                                            placeholder="Enter task name..."
                                            name="task"
                                            value={taskData.task}
                                            onChange={handleChange}
                                            error={Boolean(formErrors.task)}
                                            helperText={formErrors.task}
                                            required
                                        />
                                    </Grid>

                                    {/* 2. Project Name */}
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth variant="outlined" error={Boolean(formErrors.project_name)}>
                                            <InputLabel shrink id="edit-task-project-label">Project Name *</InputLabel>
                                            <Select
                                                labelId="edit-task-project-label"
                                                id="edit-task-project"
                                                name="project_name"
                                                value={taskData.project_name}
                                                onChange={handleChange}
                                                label="Project Name *"
                                                notched={true}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return (
                                                            <span style={{ color: '#94a3b8' }}>
                                                                {projects.length === 0 ? 'No project available' : 'Select Project'}
                                                            </span>
                                                        );
                                                    }
                                                    return selected;
                                                }}
                                                MenuProps={{ disableScrollLock: true }}
                                            >
                                                {projects.length === 0 ? (
                                                    <MenuItem value="" disabled style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                                        No project available
                                                    </MenuItem>
                                                ) : (
                                                    [
                                                        <MenuItem key="empty-select" value="" disabled style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                                            Select Project
                                                        </MenuItem>,
                                                        ...projects
                                                            .filter((project) => isProjectActive(project.status) || project.project_name === taskData.project_name)
                                                            .map((project) => (
                                                                <MenuItem key={project.id} value={project.project_name}>
                                                                    {project.project_name} {!isProjectActive(project.status) ? '(Inactive)' : ''}
                                                                </MenuItem>
                                                            ))
                                                    ]
                                                )}
                                            </Select>
                                            {formErrors.project_name && (
                                                <FormHelperText error>{formErrors.project_name}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>

                                    {/* 3. Select User (Multiple Select) - Attendance Style Popover */}
                                    <Grid item xs={12} sm={6}>
                                        <div style={{ position: 'relative' }}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                label="Select User"
                                                placeholder={(taskData.member_ids || []).length === 0 ? "Select User" : undefined}
                                                value=""
                                                required
                                                onClick={(e) => setUserPopoverAnchor(e.currentTarget)}
                                                error={Boolean(formErrors.member_ids)}
                                                helperText={formErrors.member_ids}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                    style: {
                                                        cursor: 'pointer',
                                                        padding: '0 14px',
                                                        height: '56px',
                                                        minHeight: '56px',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    startAdornment: (taskData.member_ids || []).length > 0 ? (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                width: 'calc(100% - 24px)',
                                                                overflow: 'hidden'
                                                            }}
                                                        >
                                                            <span className="tm-selected-users-text">
                                                                {taskData.member_ids.length} user(s) selected
                                                            </span>

                                                            <div
                                                                ref={avatarsScrollRef}
                                                                className="tm-avatars-scroll"
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    overflowX: 'auto',
                                                                    overflowY: 'hidden',
                                                                    maxWidth: '100%',
                                                                    padding: '4px 24px 4px 6px',
                                                                    flex: 1,
                                                                    marginRight: 8
                                                                }}
                                                            >
                                                                {taskData.member_ids.map((uid) => {
                                                                    const u = developers.find((d) => Number(d.id) === Number(uid));
                                                                    const name = u
                                                                        ? (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name)
                                                                        : `User #${uid}`;
                                                                    return (
                                                                        <Tooltip key={uid} title={name} arrow>
                                                                            <Avatar
                                                                                src={u && u.photo ? u.photo : ''}
                                                                                style={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 13,
                                                                                    fontWeight: 700,
                                                                                    flexShrink: 0,
                                                                                    backgroundColor: '#036dda',
                                                                                    color: '#ffffff',
                                                                                    border: '2px solid #ffffff',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.18)'
                                                                                }}
                                                                            >
                                                                                {getInitials(name)}
                                                                            </Avatar>
                                                                        </Tooltip>
                                                                    );
                                                                })}
                                                                <div style={{ minWidth: 20, width: 20, flexShrink: 0, height: 1 }} />
                                                            </div>
                                                        </div>
                                                    ) : null,
                                                    endAdornment: (
                                                        <InputAdornment position="end" style={{ marginLeft: 8 }}>
                                                            <ExpandMoreIcon style={{ cursor: 'pointer', color: '#666' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: {
                                                        readOnly: true,
                                                        style: {
                                                            cursor: 'pointer',
                                                            display: (taskData.member_ids || []).length > 0 ? 'none' : 'block'
                                                        }
                                                    }
                                                }}
                                            />

                                            <Popover
                                                open={Boolean(userPopoverAnchor)}
                                                anchorEl={userPopoverAnchor}
                                                onClose={() => {
                                                    setUserPopoverAnchor(null);
                                                    setUserSearchQuery('');
                                                }}
                                                disableScrollLock
                                                getContentAnchorEl={null}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    className: 'attendance-user-popover-paper',
                                                    style: {
                                                        width: userPopoverAnchor ? userPopoverAnchor.offsetWidth : 300,
                                                        maxWidth: 400,
                                                        maxHeight: 380,
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                        marginTop: '4px'
                                                    }
                                                }}
                                            >
                                                <Box p={1.5} className="attendance-user-popover-header">
                                                    <Typography
                                                        variant="subtitle2"
                                                        className="attendance-user-popover-title"
                                                        style={{
                                                            fontWeight: 700,
                                                            marginBottom: 8,
                                                            color: '#ffffff'
                                                        }}
                                                    >
                                                        Select User
                                                    </Typography>
                                                    <TextField
                                                        className="common-user-search-field"
                                                        fullWidth
                                                        size="small"
                                                        placeholder="Search users..."
                                                        value={userSearchQuery}
                                                        onChange={(e) => setUserSearchQuery(e.target.value)}
                                                        variant="outlined"
                                                        InputProps={{
                                                            style: {
                                                                backgroundColor: '#ffffff',
                                                                borderRadius: '4px',
                                                                height: '36px'
                                                            },
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SearchIcon fontSize="small" style={{ color: '#036dda' }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                                <Divider />
                                                <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                                    <MenuItem
                                                        className={`attendance-user-option ${availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id))) ? 'attendance-user-selected' : ''}`}
                                                        disabled={availableDevelopers.length === 0}
                                                        selected={availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))}
                                                        onClick={() => {
                                                            if (availableDevelopers.length === 0) return;
                                                            const allIds = availableDevelopers.map((d) => Number(d.id));
                                                            const isAllSelected = allIds.length > 0 && allIds.every((id) => (taskData.member_ids || []).map(Number).includes(id));
                                                            const nextIds = isAllSelected ? [] : allIds;
                                                            setTaskData((prev) => ({
                                                                ...prev,
                                                                member_ids: nextIds
                                                            }));
                                                            if (nextIds.length > 0 && formErrors.member_ids) {
                                                                setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                                                            }
                                                        }}
                                                        style={{
                                                            padding: '8px 16px',
                                                            backgroundColor: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#036dda' : undefined,
                                                            color: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#ffffff' : undefined,
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary="All Users"
                                                            primaryTypographyProps={{
                                                                style: {
                                                                    color: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#ffffff' : 'inherit',
                                                                    fontWeight: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? 600 : 400,
                                                                }
                                                            }}
                                                        />
                                                        {availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id))) && (
                                                            <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />
                                                        )}
                                                    </MenuItem>
                                                    {availableDevelopers
                                                        .filter((dev) => {
                                                            const q = (userSearchQuery || '').toLowerCase();
                                                            const name = (dev.firstName ? `${dev.firstName} ${dev.lastName || ''}` : dev.name || '').toLowerCase();
                                                            return name.includes(q);
                                                        })
                                                        .map((dev) => {
                                                            const devDisplayName = dev.firstName
                                                                ? `${dev.firstName} ${dev.lastName || ''}`.trim()
                                                                : dev.name;
                                                            const isChecked = (taskData.member_ids || []).map(Number).includes(Number(dev.id));
                                                            return (
                                                                <MenuItem
                                                                    key={dev.id}
                                                                    className={`attendance-user-option ${isChecked ? 'attendance-user-selected' : ''}`}
                                                                    selected={isChecked}
                                                                    onClick={() => {
                                                                        const current = (taskData.member_ids || []).map(Number);
                                                                        const updated = isChecked
                                                                            ? current.filter((id) => id !== Number(dev.id))
                                                                            : [...current, Number(dev.id)];
                                                                        setTaskData((prev) => ({
                                                                            ...prev,
                                                                            member_ids: updated
                                                                        }));
                                                                        if (updated.length > 0 && formErrors.member_ids) {
                                                                            setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        backgroundColor: isChecked ? '#036dda' : undefined,
                                                                        color: isChecked ? '#ffffff' : undefined,
                                                                    }}
                                                                >
                                                                    <Box display="flex" alignItems="center" width="100%">
                                                                        <Avatar
                                                                            src={dev.photo || ''}
                                                                            style={{
                                                                                width: 32,
                                                                                height: 32,
                                                                                marginRight: 12,
                                                                                fontSize: '0.9rem',
                                                                                border: isChecked ? '2px solid #ffffff' : 'none'
                                                                            }}
                                                                        >
                                                                            {getInitials(devDisplayName)}
                                                                        </Avatar>
                                                                        <ListItemText
                                                                            primary={devDisplayName}
                                                                            primaryTypographyProps={{
                                                                                style: {
                                                                                    color: isChecked ? '#ffffff' : 'inherit',
                                                                                    fontWeight: isChecked ? 600 : 400,
                                                                                }
                                                                            }}
                                                                        />
                                                                        {isChecked && (
                                                                            <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />
                                                                        )}
                                                                    </Box>
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    {availableDevelopers.length === 0 && (
                                                        <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                                                            {!taskData.project_name ? 'Please select a project first' : 'No users assigned to this project'}
                                                        </div>
                                                    )}
                                                </div>
                                            </Popover>
                                        </div>
                                    </Grid>

                                    {/* 4. Priority */}
                                    <Grid item xs={12} sm={3}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel id="edit-task-priority-label">Priority</InputLabel>
                                            <Select
                                                labelId="edit-task-priority-label"
                                                id="edit-task-priority"
                                                name="priority"
                                                value={taskData.priority || 'Medium'}
                                                onChange={handleChange}
                                                label="Priority"
                                                MenuProps={{ disableScrollLock: true }}
                                            >
                                                <MenuItem value="Low">Low</MenuItem>
                                                <MenuItem value="Medium">Medium</MenuItem>
                                                <MenuItem value="High">High</MenuItem>
                                                <MenuItem value="Urgent">Urgent</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* 5. Status */}
                                    <Grid item xs={12} sm={3}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel id="edit-task-status-label">Status</InputLabel>
                                            <Select
                                                labelId="edit-task-status-label"
                                                id="edit-task-status"
                                                name="status"
                                                value={taskData.status || 'Pending'}
                                                onChange={handleChange}
                                                label="Status"
                                                MenuProps={{ disableScrollLock: true }}
                                            >
                                                <MenuItem value="Backlog">Backlog</MenuItem>
                                                <MenuItem value="Pending">To Do / Pending</MenuItem>
                                                <MenuItem value="In Progress">In Progress</MenuItem>
                                                <MenuItem value="Testing">Testing / Review</MenuItem>
                                                <MenuItem value="Done">Done</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Edit time line (Max 8 hours, 00:00 format, manual typing) */}
                                    <Grid item xs={12} sm={6}>
                                        <TimelineInputField
                                            label="Edit time line"
                                            placeholder="00:00"
                                            name="timeline"
                                            id="task_timeline"
                                            value={taskData.timeline || ''}
                                            onChange={(val) => {
                                                setTaskData((prev) => ({ ...prev, timeline: val }));
                                                if (formErrors.timeline) {
                                                    setFormErrors((prev) => ({ ...prev, timeline: '' }));
                                                }
                                            }}
                                            error={Boolean(formErrors.timeline)}
                                            helperText={formErrors.timeline}
                                        />
                                    </Grid>

                                    {/* 8. Upload Files & Photos */}
                                    <Grid item xs={12} sm={6}>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            id="task-files-input"
                                            multiple
                                            accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                                            style={{ display: 'none' }}
                                            onChange={handleFileSelect}
                                        />
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Upload Files & Photos"
                                            value={taskFiles.length > 0 ? `${taskFiles.length} file${taskFiles.length > 1 ? 's' : ''} selected` : ''}
                                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                            inputProps={{
                                                readOnly: true,
                                                style: {
                                                    cursor: 'pointer',
                                                    textOverflow: 'ellipsis'
                                                }
                                            }}
                                            InputProps={{
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Tooltip title="Upload file (Images, Docs, PDF, Word)" arrow placement="top">
                                                            <IconButton
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    fileInputRef.current && fileInputRef.current.click();
                                                                }}
                                                                className="tm-desc-upload-btn"
                                                                aria-label="Upload file"
                                                            >
                                                                <TrayUploadIcon size={21} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />

                                        {/* Selected Files List */}
                                        {taskFiles.length > 0 && (
                                            <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 180, overflowY: 'auto' }}>
                                                {taskFiles.map((file, idx) => {
                                                    const fileName = file.name || (typeof file === 'string' ? file.split('/').pop() : `File ${idx + 1}`);
                                                    const isImg = file.type ? file.type.startsWith('image/') : /\.(jpg|jpeg|png|webp|gif)$/i.test(fileName);
                                                    const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(fileName);
                                                    const isWord = /\.docx?$/i.test(fileName);
                                                    return (
                                                        <div key={idx} className="tm-selected-file-item">
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden', minWidth: 0 }}>
                                                                {isImg ? (
                                                                    <ImageIcon style={{ color: '#0284c7', fontSize: 18, flexShrink: 0 }} />
                                                                ) : isPdf ? (
                                                                    <PictureAsPdfIcon style={{ color: '#ef4444', fontSize: 18, flexShrink: 0 }} />
                                                                ) : isWord ? (
                                                                    <DescriptionIcon style={{ color: '#2563eb', fontSize: 18, flexShrink: 0 }} />
                                                                ) : (
                                                                    <InsertDriveFileIcon style={{ color: '#64748b', fontSize: 18, flexShrink: 0 }} />
                                                                )}
                                                                <span
                                                                    style={{
                                                                        fontWeight: 500,
                                                                        color: 'var(--tm-text)',
                                                                        textOverflow: 'ellipsis',
                                                                        overflow: 'hidden',
                                                                        whiteSpace: 'nowrap',
                                                                        fontSize: 12
                                                                    }}
                                                                    title={fileName}
                                                                >
                                                                    {fileName}
                                                                </span>
                                                                {file.size && (
                                                                    <span style={{ fontSize: 10, color: '#64748b', flexShrink: 0 }}>
                                                                        ({(file.size / 1024).toFixed(0)}KB)
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                                                                {(file.url || file instanceof File) && (
                                                                    <Tooltip title="View file" arrow>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleViewFile(file);
                                                                            }}
                                                                            style={{ color: '#036dda', padding: 3 }}
                                                                        >
                                                                            <VisibilityIcon style={{ fontSize: 17 }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {(file.url || file instanceof File) && (
                                                                    <Tooltip title="Download file" arrow>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleDownloadFile(file);
                                                                            }}
                                                                            style={{ color: '#10b981', padding: 3 }}
                                                                        >
                                                                            <GetAppIcon style={{ fontSize: 17 }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                <Tooltip title="Remove file" arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleRemoveFile(idx);
                                                                        }}
                                                                        style={{ color: '#94a3b8', padding: 3 }}
                                                                    >
                                                                        <CloseIcon style={{ fontSize: 16 }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </Grid>

                                    {/* 9. Task Description (Material-UI Outlined TextField with Wysiwyg Rich Formatting) */}
                                    <Grid item xs={12}>
                                        <WysiwygDescriptionEditor
                                            label="Description"
                                            placeholder="Enter task description..."
                                            name="description"
                                            id="task_description"
                                            value={taskData.description || ''}
                                            onChange={(html) => {
                                                setTaskData((prev) => ({ ...prev, description: html }));
                                                if (formErrors.description) {
                                                    setFormErrors((prev) => ({ ...prev, description: '' }));
                                                }
                                            }}
                                            error={Boolean(formErrors.description)}
                                            helperText={formErrors.description}
                                            rows={4}
                                        />
                                    </Grid>

                                    {/* 10. Sub Tasks Accordion (Collapsible dropdown like Add User Other Settings) */}
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', border: '1px solid rgba(0, 0, 0, .125)', borderRadius: 4 }}>
                                            <Accordion elevation={0} style={{ background: 'transparent' }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon style={{ color: '#036dda' }} />}
                                                    aria-controls="subtask-accordion-content"
                                                    id="subtask-accordion-header"
                                                    style={{ color: '#036dda', minHeight: 48 }}
                                                >
                                                    <Typography
                                                        className="common-form-page-title"
                                                        style={{
                                                            color: 'var(--hrms-primary-blue-end, #036dda)',
                                                            fontSize: 15,
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        Edit Sub Task
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails style={{ display: 'block', padding: '12px 16px 20px 16px' }}>
                                                    {/* Quick Add Bar */}
                                                    <div
                                                        className="tm-subtask-add-bar"
                                                        style={{
                                                            opacity: editingIndex !== null ? 0.6 : 1,
                                                            transition: 'opacity 0.2s ease'
                                                        }}
                                                    >
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            variant="outlined"
                                                            label="Sub Task Title"
                                                            placeholder={
                                                                editingIndex !== null
                                                                    ? 'Finish or cancel editing below first...'
                                                                    : 'Type subtask title and press Enter...'
                                                            }
                                                            value={newSubTaskTitle}
                                                            onChange={(e) => setNewSubTaskTitle(e.target.value)}
                                                            disabled={editingIndex !== null}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    handleAddSubTask();
                                                                }
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    fontWeight: 400,
                                                                    fontSize: 14
                                                                }
                                                            }}
                                                        />
                                                        <Tooltip
                                                            title={
                                                                String(taskData.status || '').trim().toLowerCase() === 'backlog'
                                                                    ? "Main task is in Backlog, so subtask status is locked to Backlog"
                                                                    : ""
                                                            }
                                                            arrow
                                                            placement="top"
                                                        >
                                                            <FormControl
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={editingIndex !== null}
                                                                style={{ minWidth: 160 }}
                                                            >
                                                                <InputLabel id="new-subtask-status-label">
                                                                    {String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Status (Locked)' : 'Status'}
                                                                </InputLabel>
                                                                <Select
                                                                    labelId="new-subtask-status-label"
                                                                    value={String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Backlog' : newSubTaskStatus}
                                                                    onChange={(e) => {
                                                                        if (String(taskData.status || '').trim().toLowerCase() !== 'backlog') {
                                                                            setNewSubTaskStatus(e.target.value);
                                                                        }
                                                                    }}
                                                                    label={String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Status (Locked)' : 'Status'}
                                                                    MenuProps={{ disableScrollLock: true }}
                                                                >
                                                                    <MenuItem value="Backlog">Backlog</MenuItem>
                                                                    {String(taskData.status || '').trim().toLowerCase() === 'backlog' ? (
                                                                        <MenuItem
                                                                            disabled
                                                                            value=""
                                                                            style={{
                                                                                fontSize: 12,
                                                                                color: '#64748b',
                                                                                fontStyle: 'italic',
                                                                                borderTop: '1px solid #f1f5f9',
                                                                                marginTop: 4,
                                                                                paddingTop: 8,
                                                                                cursor: 'default',
                                                                                whiteSpace: 'normal',
                                                                                lineHeight: 1.3
                                                                            }}
                                                                        >
                                                                            ℹ️ Main task is Backlog (Locked)
                                                                        </MenuItem>
                                                                    ) : (
                                                                        [
                                                                            <MenuItem key="Pending" value="Pending">Pending</MenuItem>,
                                                                            <MenuItem key="In Progress" value="In Progress">In Progress</MenuItem>,
                                                                            <MenuItem key="Testing" value="Testing">Testing</MenuItem>,
                                                                            <MenuItem key="Done" value="Done">Done</MenuItem>
                                                                        ]
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        </Tooltip>
                                                        <Button
                                                            type="button"
                                                            variant="contained"
                                                            disabled={editingIndex !== null}
                                                            onClick={handleAddSubTask}
                                                            style={{
                                                                backgroundColor: editingIndex !== null ? '#94a3b8' : '#036dda',
                                                                color: '#ffffff',
                                                                textTransform: 'none',
                                                                fontWeight: 600,
                                                                fontSize: 14,
                                                                height: 40,
                                                                minWidth: 120,
                                                                padding: '0 20px',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                textAlign: 'center',
                                                                lineHeight: 1,
                                                                whiteSpace: 'nowrap',
                                                                boxShadow: 'none',
                                                                cursor: editingIndex !== null ? 'not-allowed' : 'pointer'
                                                            }}
                                                        >
                                                            Add Subtask
                                                        </Button>
                                                    </div>

                                                    {/* Subtasks List */}
                                                    {subTasks.length > 0 ? (
                                                        <div className="tm-subtask-list">
                                                            {subTasks.map((sub, index) => {
                                                                const isEditing = editingIndex === index;
                                                                const statusClass = `tm-subtask-status-${(sub.status || 'pending').toLowerCase().replace(/\s+/g, '')}`;

                                                                if (isEditing) {
                                                                    // INLINE EDIT MODE
                                                                    return (
                                                                        <div key={index} className="tm-subtask-row tm-subtask-row-edit">
                                                                            <TextField
                                                                                fullWidth
                                                                                size="small"
                                                                                variant="outlined"
                                                                                label="Sub Task Title"
                                                                                value={editSubTaskTitle}
                                                                                onChange={(e) => setEditSubTaskTitle(e.target.value)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        handleSaveEditSubTask(index);
                                                                                    }
                                                                                }}
                                                                                style={{ background: '#ffffff', borderRadius: 4 }}
                                                                                inputProps={{
                                                                                    style: {
                                                                                        fontWeight: 400,
                                                                                        fontSize: 14
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <Tooltip
                                                                                title={
                                                                                    String(taskData.status || '').trim().toLowerCase() === 'backlog'
                                                                                        ? "Main task is in Backlog, so subtask status is locked to Backlog"
                                                                                        : ""
                                                                                }
                                                                                arrow
                                                                                placement="top"
                                                                            >
                                                                                <FormControl variant="outlined" size="small" style={{ minWidth: 160, background: '#ffffff', borderRadius: 4 }}>
                                                                                    <InputLabel id={`edit-subtask-status-${index}`}>
                                                                                        {String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Status (Locked)' : 'Status'}
                                                                                    </InputLabel>
                                                                                    <Select
                                                                                        labelId={`edit-subtask-status-${index}`}
                                                                                        value={String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Backlog' : editSubTaskStatus}
                                                                                        onChange={(e) => {
                                                                                            if (String(taskData.status || '').trim().toLowerCase() !== 'backlog') {
                                                                                                setEditSubTaskStatus(e.target.value);
                                                                                            }
                                                                                        }}
                                                                                        label={String(taskData.status || '').trim().toLowerCase() === 'backlog' ? 'Status (Locked)' : 'Status'}
                                                                                        MenuProps={{ disableScrollLock: true }}
                                                                                    >
                                                                                        <MenuItem value="Backlog">Backlog</MenuItem>
                                                                                        {String(taskData.status || '').trim().toLowerCase() === 'backlog' ? (
                                                                                            <MenuItem
                                                                                                disabled
                                                                                                value=""
                                                                                                style={{
                                                                                                    fontSize: 12,
                                                                                                    color: '#64748b',
                                                                                                    fontStyle: 'italic',
                                                                                                    borderTop: '1px solid #f1f5f9',
                                                                                                    marginTop: 4,
                                                                                                    paddingTop: 8,
                                                                                                    cursor: 'default',
                                                                                                    whiteSpace: 'normal',
                                                                                                    lineHeight: 1.3
                                                                                                }}
                                                                                            >
                                                                                                ℹ️ Main task is Backlog (Locked)
                                                                                            </MenuItem>
                                                                                        ) : (
                                                                                            [
                                                                                                <MenuItem key="Pending" value="Pending">Pending</MenuItem>,
                                                                                                <MenuItem key="In Progress" value="In Progress">In Progress</MenuItem>,
                                                                                                <MenuItem key="Testing" value="Testing">Testing</MenuItem>,
                                                                                                <MenuItem key="Done" value="Done">Done</MenuItem>
                                                                                            ]
                                                                                        )}
                                                                                    </Select>
                                                                                </FormControl>
                                                                            </Tooltip>
                                                                            <div className="tm-subtask-actions" style={{ gap: 8 }}>
                                                                                <Button
                                                                                    type="button"
                                                                                    size="small"
                                                                                    variant="contained"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        handleSaveEditSubTask(index);
                                                                                    }}
                                                                                    style={{
                                                                                        backgroundColor: '#036dda',
                                                                                        color: '#ffffff',
                                                                                        textTransform: 'none',
                                                                                        fontWeight: 600,
                                                                                        fontSize: 13,
                                                                                        height: 38,
                                                                                        minWidth: 80,
                                                                                        padding: '0 18px',
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        textAlign: 'center',
                                                                                        lineHeight: 1,
                                                                                        boxShadow: 'none'
                                                                                    }}
                                                                                >
                                                                                    Update
                                                                                </Button>
                                                                                <Button
                                                                                    type="button"
                                                                                    size="small"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        handleCancelEditSubTask();
                                                                                    }}
                                                                                    style={{
                                                                                        backgroundColor: '#f1f5f9',
                                                                                        color: '#475569',
                                                                                        textTransform: 'none',
                                                                                        fontWeight: 600,
                                                                                        fontSize: 13,
                                                                                        height: 38,
                                                                                        minWidth: 80,
                                                                                        padding: '0 18px',
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        textAlign: 'center',
                                                                                        lineHeight: 1
                                                                                    }}
                                                                                >
                                                                                    Cancel
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }

                                                                // NORMAL VIEW MODE
                                                                return (
                                                                    <div key={index} className="tm-subtask-row">
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
                                                                            <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--tm-text, #1e293b)' }}>
                                                                                {sub.name || sub.title || sub.task_name || sub.task || sub.details || 'Untitled Subtask'}
                                                                            </span>
                                                                        </div>

                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                                            <span className={`tm-subtask-status-pill ${statusClass}`}>
                                                                                {sub.status || 'Pending'}
                                                                            </span>

                                                                            <div className="tm-subtask-actions">
                                                                                <Tooltip title="Edit Subtask">
                                                                                    <IconButton
                                                                                        type="button"
                                                                                        size="small"
                                                                                        className="common-action-icon"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            handleStartEditSubTask(index);
                                                                                        }}
                                                                                        style={{ padding: 6 }}
                                                                                    >
                                                                                        <FontAwesomeIconComponent
                                                                                            classes="fa fa-edit"
                                                                                            colorName="primary"
                                                                                            fontSize="small"
                                                                                        />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                <Tooltip title="Delete Subtask">
                                                                                    <IconButton
                                                                                        type="button"
                                                                                        size="small"
                                                                                        className="common-action-icon"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            handleDeleteSubTask(index);
                                                                                        }}
                                                                                        style={{ padding: 6 }}
                                                                                    >
                                                                                        <FontAwesomeIconComponent
                                                                                            classes="fa fa-trash"
                                                                                            colorName="primary"
                                                                                            fontSize="small"
                                                                                        />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ) : (
                                                        <div className="tm-subtask-empty">
                                                            No subtasks added yet. Type a title above and click "Add Subtask".
                                                        </div>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </Grid>

                                    {/* Buttons */}
                                    <Grid item xs={12} style={{ display: 'flex', gap: 12, marginTop: 10 }}>
                                        <Button
                                            type="submit"
                                            className="btn-success"
                                            style={{ textTransform: 'none' }}
                                            variant="contained"
                                            color="primary"
                                            disabled={submitLoading}
                                        >
                                            {submitLoading ? (
                                                <>
                                                    <CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Updating...
                                                </>
                                            ) : (
                                                'Save'
                                            )}
                                        </Button>
                                        <Button
                                            type="button"
                                            className="btn-cancel"
                                            style={{ textTransform: 'none' }}
                                            disabled={submitLoading}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                props.history.push('/tasks');
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </div>
                } />
            <FilePreviewDialog
                open={Boolean(previewFile)}
                file={previewFile}
                onClose={() => setPreviewFile(null)}
                onDownload={handleDownloadFile}
            />
            <Footer />
        </div>
    )
}

export default EditTask;
